import { render, staticRenderFns } from "./Detail-Engineer.vue?vue&type=template&id=d0131aba"
import script from "./Detail-Engineer.vue?vue&type=script&lang=js"
export * from "./Detail-Engineer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports